import React from 'react';
export function Privacy() {
  return <div className="pt-10 pb-20" data-id="element-399">
      <div className="bg-gray-50 py-16 mb-12" data-id="element-400">
        <div className="container-custom" data-id="element-401">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-402">
            Privacy Policy
          </h1>
          <p className="text-gray-600" data-id="element-403">Last Updated: January 2024</p>
        </div>
      </div>

      <div className="container-custom max-w-4xl" data-id="element-404">
        <div className="prose prose-blue max-w-none text-gray-700" data-id="element-405">
          <h3 data-id="element-406">1. Introduction</h3>
          <p data-id="element-407">
            Brixen Consulting FZCO ("we," "us," or "our") respects your privacy
            and is committed to protecting your personal data. This Privacy
            Policy explains how we collect, use, and safeguard your information
            when you visit our website or use our services.
          </p>

          <h3 data-id="element-408">2. Information We Collect</h3>
          <p data-id="element-409">We may collect the following types of information:</p>
          <ul data-id="element-410">
            <li data-id="element-411">
              <strong data-id="element-412">Personal Identification Information:</strong> Name, email
              address, phone number, company name, and job title.
            </li>
            <li data-id="element-413">
              <strong data-id="element-414">Business Information:</strong> Details about your business
              activities, requirements, and documentation provided for service
              execution.
            </li>
            <li data-id="element-415">
              <strong data-id="element-416">Usage Data:</strong> Information about how you use our
              website, including IP address, browser type, and pages visited.
            </li>
          </ul>

          <h3 data-id="element-417">3. How We Use Your Information</h3>
          <p data-id="element-418">We use your data for the following purposes:</p>
          <ul data-id="element-419">
            <li data-id="element-420">To provide and manage our corporate services.</li>
            <li data-id="element-421">
              To communicate with you regarding your inquiries and service
              updates.
            </li>
            <li data-id="element-422">
              To comply with legal and regulatory obligations (e.g., KYC/AML
              checks).
            </li>
            <li data-id="element-423">To improve our website and customer experience.</li>
          </ul>

          <h3 data-id="element-424">4. Legal Basis for Processing</h3>
          <p data-id="element-425">We process your personal data based on:</p>
          <ul data-id="element-426">
            <li data-id="element-427">
              <strong data-id="element-428">Consent:</strong> When you voluntarily provide information
              via contact forms.
            </li>
            <li data-id="element-429">
              <strong data-id="element-430">Contractual Necessity:</strong> To fulfill our service
              agreement with you.
            </li>
            <li data-id="element-431">
              <strong data-id="element-432">Legal Obligation:</strong> To comply with UAE laws and
              regulations.
            </li>
            <li data-id="element-433">
              <strong data-id="element-434">Legitimate Interests:</strong> For business administration
              and improvement.
            </li>
          </ul>

          <h3 data-id="element-435">5. Cookies</h3>
          <p data-id="element-436">
            Our website uses cookies to enhance your browsing experience. You
            can choose to disable cookies through your browser settings, but
            this may affect the functionality of the site.
          </p>

          <h3 data-id="element-437">6. Data Sharing</h3>
          <p data-id="element-438">
            We do not sell your personal data. We may share your information
            with:
          </p>
          <ul data-id="element-439">
            <li data-id="element-440">
              Government authorities and free zone regulators as required for
              company setup.
            </li>
            <li data-id="element-441">
              Trusted third-party service providers (e.g., banking partners,
              auditors) with your consent.
            </li>
            <li data-id="element-442">Legal authorities if required by law.</li>
          </ul>

          <h3 data-id="element-443">7. International Transfers</h3>
          <p data-id="element-444">
            Your information may be transferred to and processed in countries
            other than your country of residence. We ensure appropriate
            safeguards are in place for such transfers.
          </p>

          <h3 data-id="element-445">8. Data Retention</h3>
          <p data-id="element-446">
            We retain your personal data only for as long as necessary to
            fulfill the purposes for which it was collected, including for the
            purposes of satisfying any legal, accounting, or reporting
            requirements.
          </p>

          <h3 data-id="element-447">9. Data Security</h3>
          <p data-id="element-448">
            We implement appropriate technical and organizational measures to
            protect your personal data against unauthorized access, alteration,
            disclosure, or destruction.
          </p>

          <h3 data-id="element-449">10. Your Rights</h3>
          <p data-id="element-450">You have the right to:</p>
          <ul data-id="element-451">
            <li data-id="element-452">Access your personal data.</li>
            <li data-id="element-453">Request correction of inaccurate data.</li>
            <li data-id="element-454">
              Request deletion of your data (subject to legal retention
              requirements).
            </li>
            <li data-id="element-455">Withdraw consent where applicable.</li>
          </ul>

          <h3 data-id="element-456">11. Contact Us</h3>
          <p data-id="element-457">
            If you have any questions about this Privacy Policy or wish to
            exercise your rights, please contact us at:
            <br data-id="element-458" />
            <strong data-id="element-459">Email:</strong> info@brixenconsulting.com
          </p>
        </div>
      </div>
    </div>;
}